export const HeartFilledIcon = ({ className = "" }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 19"
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        d="M14.5 1c1.318 0 2.366.43 3.218 1.282S19 4.182 19 5.5q0 .977-.331 1.918c-.215.61-.61 1.324-1.222 2.148-.611.823-1.45 1.773-2.529 2.852q-1.625 1.625-4.138 3.889l-.78.699-.781-.7q-2.512-2.264-4.137-3.888c-1.079-1.079-1.918-2.028-2.53-2.852S1.547 8.027 1.332 7.418A5.7 5.7 0 0 1 1 5.5c0-1.318.43-2.366 1.282-3.218S4.182 1 5.5 1c.72 0 1.4.152 2.05.456a4.9 4.9 0 0 1 1.688 1.292l.762.897.762-.897a4.9 4.9 0 0 1 1.687-1.292A4.8 4.8 0 0 1 14.5 1Z"
      />
    </svg>
  );
};
